export { ButtonComponent } from './button/button.component';
export { SwitchComponent } from './switch-v2/switch.component';
export { IconComponent } from './icon/icon.component';
export { InputComponent } from './input/input.component';
export { DialogComponent } from './dialog/dialog.component';
export { TabsComponent } from './tabs/tabs.component';
export { ScrollContainerComponent } from './scroll-container/scroll-container.component';
export { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
export { StepMenuComponent } from './step-menu/step-menu.component';
export { HeaderComponent } from './header/header.component';